import axios from 'axios'
import qs from 'qs'
import { resolve } from 'url';

// const requestUrl = 'http://qy.chinapsp.cn:45100'
const requestUrl = location.href.indexOf('qy.chinapsp.cn') != -1 ? 'http://qy.chinapsp.cn:45100':'http://192.168.166.141:8886'

/**
 * 发起流程
 * @param {*} param0 appId:流程代号，NP立项工作流，FS发售稿，CG初稿; userphone:用户手机号; wiid:流程用Id,GUID; flowTitle:流程名称; businessKey:附带参数
 * @param {*} param1 nextActivityCode:下一个流程编号; userId:接收流程人员
 */
function startWorkflow({ appId = '', userPhone = '', wiid = '', flowTitle = '', businessKey = '', opinion = '-' } = {}, { nextActivityCode = '', userId = '' } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/StartWorkflow/', qs.stringify({
        "authorJson": JSON.stringify({
          "loginAccount": userPhone
        }),
        "parmJson": JSON.stringify({
          "appId": appId,
          "wiid": wiid,
          "businessKey": businessKey,//用途不明
          "title": flowTitle,
          "opinion": opinion,
          "toUserNameOrId": "",//用途不明
          // "toActivityList": "{'" + nextActivityCode + "':'" + userId + "'}",
          "toActivityList": `{'${nextActivityCode}':'${userId}'}`,
          "processVariablesJson": ""//用途不明
        }),
      }))
      if (rep.data.success) {
        resolve(rep.data)
      } else {
        reject(rep.data)
      }
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

/**
 * 获取下一步节点用户
 * @param {*} param0 appId:流程代号，NP立项工作流，FS发售稿，CG初稿; userphone:用户手机号; taskId:流程Id(可不传，得到所有人员，第一次发起)
 */
function getActivityUsers({ appId = '', userPhone = '', taskId = '', processVariablesJson = '' } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/GetActivityInfoIUsers', qs.stringify({
        authorJson: JSON.stringify({
          "loginAccount": userPhone
        }),
        parmJson: JSON.stringify({
          "appId": appId,
          "taskId": taskId,
          "processVariablesJson": processVariablesJson
        })
      }))
      resolve(rep.data)
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

/**
 * 获取流程历史
 * @param {*} userPhone 用户手机
 * @param {*} wiid 流程wiid
 */
function getFlowHistory(userPhone, wiid) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/GetTodoApprovalRecordByWiid', qs.stringify({
        authorJson: JSON.stringify({
          "loginAccount": userPhone
        }),
        parmJson: JSON.stringify({
          "wiid": wiid,
        })
      }))
      resolve(rep.data)
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

/**
 * 获取代办
 * @param {*} userPhone 用户号码
 * @param {*} param1 page:页码; size:每页数量; whereStr:筛选，AppId='NP'立项,AppId='FS'发售稿,AppId='CG'初稿
 */
function getToDoList(userPhone, { page = 1, size = 8, whereStr = '' } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/GetTodoList', qs.stringify({
        authorJson: JSON.stringify({
          "loginAccount": userPhone
        }),
        parmJson: JSON.stringify({
          "pageIndex": page,
          "pageSize": size,
          "sort": "CreatedTime",
          "order": "desc",
          "whereStr": whereStr
        })
      }))
      if (rep.data.success) {
        resolve(rep.data)
      } else {
        reject(rep.data)
      }
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

// 获取我的流程
function getMyWorkItem(userPhone, { page = 1, size = 8, whereStr = '', isHistory = 0 } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/GetMyWorkItem', qs.stringify({
        authorJson: JSON.stringify({
          "loginAccount": userPhone
        }),
        parmJson: JSON.stringify({
          "isHistory": isHistory,
          "pageIndex": page,
          "pageSize": size,
          "sort": "CreatedTime",
          "order": "desc",
          "whereStr": whereStr
        })
      }))
      if (rep.data.success) {
        resolve(rep.data)
      } else {
        reject(rep.data)
      }
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

// 获取经办流程
function getGetDoneList(userPhone, { page = 1, size = 8, whereStr = '', isHistory = 0 } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      let sort = 'CreatedTime'
      if (isHistory) {
        sort = 'FinishedTime'
      }
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/GetDoneList', qs.stringify({
        authorJson: JSON.stringify({
          "loginAccount": userPhone
        }),
        parmJson: JSON.stringify({
          "isHistory": isHistory,
          "pageIndex": page,
          "pageSize": size,
          "sort": sort,
          "order": "desc",
          "whereStr": whereStr
        })
      }))
      if (rep.data.success) {
        resolve(rep.data)
      } else {
        reject(rep.data)
      }
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

// 流程转交
function deliverFlow(userPhone, { taskId = '', nextActivityCode = '', userId = '', processVariablesJson = '', opinion = '-' } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/ApprovalTask', qs.stringify({
        "authorJson": JSON.stringify({
          "loginAccount": userPhone
        }),
        "parmJson": JSON.stringify({
          "taskId": taskId,
          "opinion": opinion,
          "toActivityList": "{'" + nextActivityCode + "':'" + userId + "'}",
          "processVariablesJson": processVariablesJson,
        })
      }))
      resolve(rep.data)
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

// 结束流程
function endFlow(userPhone, { taskId = '', nextActivityCode = '', opinion = '-' } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/ApprovalTask', qs.stringify({
        "authorJson": JSON.stringify({
          "loginAccount": userPhone
        }),
        "parmJson": JSON.stringify({
          "taskId": taskId,
          "opinion": opinion,
          "toActivityList": "{'" + nextActivityCode + "':''}",
          "processVariablesJson": "",
        })
      }))
      resolve(rep.data)
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

// 驳回流程
function rejectFlow(userPhone, { taskId, activityCode, opinion }) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/RejectFlow', qs.stringify({
        authorJson: JSON.stringify({
          "loginAccount": userPhone
        }),
        parmJson: JSON.stringify({
          "taskId": taskId,
          "toActivityCode": activityCode,
          "opinion": opinion
        })
      }))
      resolve(rep.data)
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

// 获取驳回节点人员
function getRejectActivityUsers(userPhone, taskId) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowBusinessRESTfullApi/RejectActivityList/', qs.stringify({
        authorJson: JSON.stringify({
          "loginAccount": userPhone
        }),
        parmJson: JSON.stringify({
          "taskId": taskId
        })
      }))
      resolve(rep.data)
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

// 删除流程实例
function deleteWorkFlow(wiid) {
  return new Promise(async (resolve, reject) => {
    try {
      let rep = await axios.post(requestUrl + '/WorkflowManage/Deletewii', qs.stringify({
        wiid: wiid
      }))
      resolve(rep.data)
    } catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

export { startWorkflow, getActivityUsers, getFlowHistory, getToDoList, endFlow, getRejectActivityUsers, rejectFlow, deliverFlow, getMyWorkItem, getGetDoneList, deleteWorkFlow }